module.exports = __webpack_public_path__ + "static/media/ratingPending.cc70f274.png";